import React, { useState, useEffect } from "react";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { ACTIVITY_STATUS, STATUS_MAPPING } from "../../common/Constants";
import FormRenderer, { ComponentMapper, FormTemplate, componentTypes } from "../../common/FormRenderer";
import { preventDefault } from "../../../utils/common";
import { validatorTypes } from "@data-driven-forms/react-form-renderer";
import { toast } from "react-toastify";

function PublishAgainModal({ onClose, onSubmit, selectedRows, isEmail, audit }: any) {
  const [counts, setCounts] = useState<any[]>([]);
  const [form, setForm] = useState<any>({});
  const [details, setDetails] = useState<any>({ hideButtons: true })

  const schema = {
    fields: [
      {
        component: componentTypes.TEXT_FIELD,
        name: 'vendor_nature_of_work',
        label: 'Vendor Nature of Work',
        placeholder: 'Enter Vendor Nature of Work...',
        validate: [
          { type: validatorTypes.REQUIRED }
        ]
      },
      {
        component: componentTypes.TEXT_FIELD,
        name: 'employee_head_count',
        label: 'Employee Head Count',
        placeholder: 'Enter Employee Head Count...',
        validate: [
          { type: validatorTypes.REQUIRED }
        ]
      },
      {
        component: componentTypes.DATE_PICKER,
        name: 'audit_start_date',
        label: 'Audit Start Date',
        className: 'grid-col-100',
        range: false,
        clearable: true,
        onChange: onStartDateChange,
        validate: [
          { type: validatorTypes.REQUIRED }
        ]
      },
      {
        component: componentTypes.DATE_PICKER,
        name: 'audit_end_date',
        label: 'Audit End Date',
        className: 'grid-col-100',
        range: false,
        clearable: true,
        onChange: onEndDateChange,
        validate: [
          { type: validatorTypes.REQUIRED }
        ]
      },
      {
        component: componentTypes.TEXT_EDITOR,
        name: 'observations',
        label: 'Observations',
        placeholder: 'Enter Observations...',
        initialValue: audit.observations || ""
      },
      {
        component: componentTypes.TEXT_EDITOR,
        name: 'recommendations',
        label: 'Recommendations',
        placeholder: 'Enter Recommendations...',
        initialValue: audit.recommendations || ""
      },
    ]
  };

  function debugForm(_form: any) {
    setForm(_form);
    setDetails(_form.values);
  }

  function handleSubmit(e: any) {
    preventDefault(e);
    if (form.valid) {
      const { recommendations, observations, vendor_nature_of_work, employee_head_count, audit_start_date, audit_end_date } = details;
      onSubmit(e, { recommendations, observations, vendor_nature_of_work, employee_head_count, audit_start_date, audit_end_date });
    } else {
      toast.error("Please fill all the mandatory fields.");
    }
  }

  useEffect(() => {
    if (selectedRows) {
      const _counts: any = {};
      selectedRows.forEach((row: any) => {
        if (!_counts[row.status]) {
          _counts[row.status] = 0;
        }
        _counts[row.status] = _counts[row.status] + 1;
      });

      setCounts(Object.keys(_counts).map((key: any) => {
        return {
          key,
          label: key === ACTIVITY_STATUS.PENDING ? `${STATUS_MAPPING[key]} (No Audit Activities)` :  STATUS_MAPPING[key],
          count: _counts[key]
        }
      }));
    }
  }, [selectedRows]);

  function onStartDateChange(event: any) {
    setDetails({ ...details, audit_start_date: event })
  }

  function onEndDateChange(event: any) {
    setDetails({ ...details, audit_end_date: event })
  }

  return (
    <>
      <Modal show={true} backdrop="static" animation={false} size="lg">
        <Modal.Header closeButton={true} onHide={onClose}>
          <Modal.Title className="bg">
            {isEmail ? "Publish and trigger email" : "Publish and trigger without email"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row mb-4">
            <div className="col-12">
              <p>There are <strong>{selectedRows.length} {selectedRows.length > 1 ? 'activities' : 'activity'}</strong> available for publishing.</p>
              <div className="row justify-content-center my-3">
                <div className="col-8">
                  {
                    counts.map(count => {
                      return (
                        <div className="row my-1" key={count.key}>
                          <div className={`col-7 status-${count.key}`}><strong>{count.label}</strong></div>
                          <div className="col-4">{count.count}</div>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
              <FormRenderer FormTemplate={FormTemplate}
                initialValues={details}
                componentMapper={ComponentMapper}
                schema={schema}
                debug={debugForm}
              />
              <p>Are you sure you <span style={{fontWeight: "bold"}}>{isEmail ? "" : "don't"} want to notify all the vendor users, vendor admins, auditor users, auditor admins and customers</span> tagged to these audits?</p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <Button variant="outline-secondary" onClick={onClose} className="btn btn-outline-secondary">
            No
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default PublishAgainModal;